import DateTimeSelect from 'components/Form/DateTimeSelect';
import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import Layout from 'components/Layout';
import LinkButton from 'components/LinkButton';
import {snakeCase} from 'lodash';
import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {t} from 'ttag';
import {jstDateString} from 'utils/date';
import {setUrl} from 'utils/request';

import {FilterFormData} from '../types';

const Filter: FC<{isFiltered: boolean}> = ({isFiltered}) => {
    const {handleSubmit} = useFormContext<FilterFormData>();

    const onFilter = (formData: FilterFormData) => {
        const builtUrl = new URL(window.location.href.split('?')[0]);

        const queryParameters = new URLSearchParams(builtUrl.search);

        Object.entries(formData).forEach(([key, value]) => {
            if (value) {
                if (key === 'dateBegin' || key === 'dateEnd') {
                    queryParameters.append(
                        snakeCase(key),
                        jstDateString(value),
                    );
                } else {
                    queryParameters.append(snakeCase(key), value);
                }
            }
        });

        builtUrl.search = queryParameters.toString();

        setUrl(builtUrl.toString());
    };

    return (
        <form onSubmit={handleSubmit(onFilter)}>
            <Layout.Chain className="mt-4 max-w-md">
                <InputText
                    className="min-w-32 flex-1"
                    classNameInput="w-full"
                    isCompact={true}
                    name="search"
                    placeholder={t`Search`}
                />
                <DateTimeSelect
                    isCompact={true}
                    name="dateBegin"
                    placeholder={t`From`}
                />
                <DateTimeSelect
                    isCompact={true}
                    name="dateEnd"
                    placeholder={t`To`}
                />
                <SubmitButton
                    className="min-w-10"
                    icon="search"
                    kind="secondary"
                    size="sm"
                    title={t`Filter`}
                />
                {isFiltered && (
                    <LinkButton
                        className="min-w-10"
                        href={window.Urls.past_order_list_view()}
                        icon="close"
                        kind="secondary"
                        size="sm"
                        title={t`Clear`}
                    />
                )}
            </Layout.Chain>
        </form>
    );
};

export default Filter;
